export enum SectionCardVariantEnum {
  FILLED,
  SURFACE,
}
